import { FindingType } from "@/common/api/findings/findings.model";
import {
  ApplicationType,
  DataSourceType,
} from "@/views/customize/data-sources/data/model";
import { BaseAppScript } from "../../data/models";
import { SecurityPostureType } from "@/views/customize/data-sources/data/model";

export type PlaybookType = "Offline" | "Cloud";

export interface FindingsCriteria {
  findingTypes: FindingType[];
  labelIds: string[];
  serviceId: DataSourceType;
  applicationId: ApplicationType;
}

export type PlaybookDataType = "Generated" | "Uploaded";

export type PlaybookDataExecutionStatus =
  | "New"
  | "BuildScheduled"
  | "Building"
  | "Ready"
  | "BuildingCancelled"
  | "RunScheduled"
  | "Running"
  | "Finishing"
  | "Finished"
  | "StopScheduled"
  | "Stopping"
  | "Stopped"
  | "Terminating"
  | "Terminated";

export const PlaybookDataExecutionStatusHelper = {
  to_readable_status: (status: PlaybookDataExecutionStatus): string => {
    switch (status) {
      case "BuildScheduled":
        return "Build Scheduled";
      case "BuildingCancelled":
        return "Building Cancelled";
      case "RunScheduled":
        return "Run Scheduled";
      case "StopScheduled":
        return "Stop Scheduled";
      default:
        return status;
    }
  },
};

export interface PlaybookDataScope extends FindingsCriteria {
  sessionId: number;
  itemsCount: number;
}

export interface PlaybookDescriptor extends BaseAppScript {
  id: string;
  criteria: FindingsCriteria;
  posture: SecurityPostureType;
  display: {
    entity_type: string;
    template_title: string;
    long_desc: string;
    pseudo_script: string;
  };
}

/* export interface PlaybookDescriptor {
  id: string;
  name: string;
  type: PlaybookType;
  criteria: FindingsCriteria;
  display: {
    title: string;
    short_desc: string;
    template_title: string;
    long_desc: string;
    pseudo_script: string;
  };
}
 */
export interface PlaybookDataRuntimeScope {
  // session id for the playbook data runtime
  sessionId: number;
  // uniq service id for playbooks
  serviceId: string;
  applicationId: string;
  appId: string;
}

export interface PlaybookDataDescriptor {
  id: string;
  playbookId: string;
  type: PlaybookDataType;
  status: PlaybookDataExecutionStatus;
  createdAt: string;
  createdById: string;
  createdByName: string;
  scope: PlaybookDataScope;
  runtimeScope: PlaybookDataRuntimeScope;
}
